import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Input, FormFeedback } from 'reactstrap';
import DateTimePicker from '../DateTimePicker/DateTimePicker';
import {
    buildVotesNotBeforeValue,
    getCommittedValueOnModeChange,
    parseVotesNotBeforeValue,
    VOTES_NOT_BEFORE_MODE_FIXED,
    VOTES_NOT_BEFORE_SCREENING_START,
    VOTES_NOT_BEFORE_SCREENING_STOP,
} from './votesNotBeforeFieldCore';

/**
 * Date field for votes.not_before: screening.start_at, screening.stop_at, or ISO date.
 */
const VotesNotBeforeField = ({ input, meta, ...rest }) => {
    const { t } = useTranslation();
    const initialState = parseVotesNotBeforeValue(input.value);
    const [mode, setMode] = useState(initialState.mode);
    const [fixedDate, setFixedDate] = useState(initialState.fixedDate);
    const [showInvalid, setShowInvalid] = useState(initialState.invalid);

    useEffect(() => {
        const nextState = parseVotesNotBeforeValue(input.value);
        setMode(nextState.mode);
        setFixedDate(nextState.fixedDate);
        setShowInvalid(nextState.invalid);
    }, [input.value]);

    const onModeChange = event => {
        const nextMode = event.target.value;
        setMode(nextMode);
        setShowInvalid(false);

        const nextValue = getCommittedValueOnModeChange(nextMode, fixedDate);
        if (nextValue !== null)
            input.onChange(nextValue);
    };

    const onFixedDateChange = value => {
        let nextFixedDate = value;

        if (moment.isMoment(value))
            nextFixedDate = value.toISOString();
        else if (typeof value === 'string')
            nextFixedDate = value.trim();

        setFixedDate(nextFixedDate);
        setShowInvalid(false);
        input.onChange(buildVotesNotBeforeValue(VOTES_NOT_BEFORE_MODE_FIXED, nextFixedDate));
    };

    return (
        <div className="VotesNotBeforeField">
            <Input
                type="select"
                value={mode}
                onChange={onModeChange}
                invalid={showInvalid || !!(meta?.touched && meta?.error)}
            >
                <option value={VOTES_NOT_BEFORE_SCREENING_START}>
                    {t('settings.votes.not_before_screening_start')}
                </option>
                <option value={VOTES_NOT_BEFORE_SCREENING_STOP}>
                    {t('settings.votes.not_before_screening_stop')}
                </option>
                <option value={VOTES_NOT_BEFORE_MODE_FIXED}>
                    {t('settings.votes.not_before_fixed')}
                </option>
            </Input>
            {mode === VOTES_NOT_BEFORE_MODE_FIXED && (
                <div className="mt-2">
                    <DateTimePicker
                        input={{
                            value: fixedDate,
                            onChange: onFixedDateChange,
                        }}
                        meta={meta}
                        {...rest}
                    />
                </div>
            )}
            {showInvalid && (
                <FormFeedback className="d-block">
                    {t('settings.votes.not_before_invalid')}
                </FormFeedback>
            )}
        </div>
    );
};

export default VotesNotBeforeField;
